/* eslint-disable consistent-return */
import isEmpty from 'lodash/isEmpty'
import encryption from './encryption'

let cache = {}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', () => {
    cache = {}
  })
}

const secureLs = {
  getItem: name => {
    if (cache[name] !== undefined) return cache[name]

    const data = localStorage.getItem(encryption.encryptWithMD5(name))
    let state
    if (!isEmpty(data)) {
      const result = encryption.decryptWithAES(data)
      try {
        state = JSON.parse(result)
      } catch (error) {
        state = result
      }

      cache[name] = state
      return state
    }
  },
  setItem: (name, data) => {
    let state = data
    if (typeof data === 'string') {
      try {
        state = JSON.parse(data)
      } catch (error) {
        state = data
      }
    }
    cache[name] = state
    localStorage.setItem(
      encryption.encryptWithMD5(name),
      encryption.encryptWithAES(data),
    )
  },
  removeItem: name => {
    delete cache[name]
    localStorage.removeItem(encryption.encryptWithMD5(name))
  },
  clearItem: () => {
    cache = {}
    localStorage.clear()
  },
}

export default secureLs
